<template>
  <div>
    <loading show="true" label="Loading..."></loading>
    <main class="site-content">
      <section class="hero is-danger">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              IceTiger.eu
            </h1>
            <h2 class="subtitle" style="margin-top: 0.5vh;">
              Into the past
            </h2>
            <!-- Internet Explorer User may encounter some problems -->
            <div v-if="isIE" class="notification is-danger">
              <div class="has-text-centered">This site is not optimized for Internet Explorer and may not work like expected!</div>
            </div>
          </div>
        </div>
      </section>
      <loading :show="isLoading" overlay="false" ></loading>
      <section class="section">
        <div class="container" v-for="event of events" :key="event.named_id" >
          <div class="notification is-danger" v-if="error">
            <div class="has-text-centered">The event api server is currently not available! Click here for the <router-link to="/event/next">next event</router-link>.</div>
          </div>
          <div class="card" v-else>
            <header class="card-header">
              <p class="card-header-title">
                <router-link :to="'/event/' + event.named_id">{{ event.name }}</router-link>
              </p>
            </header>
            <div class="card-content">
              <div class="content">
                <p class="title is-4"><a :href="event.url">{{ event.subtitle }}</a></p>
              </div>
            </div>
            <footer class="card-footer">
              <router-link :to="'/event/' + event.named_id" class="card-footer-item"> More details</router-link>
              <a :href="event.provider.footTwitterUrl" class="card-footer-item">{{event.provider.name}} on Twitter</a>
            </footer>
          </div>
        </div>
      </section>
    </main>
    <vue-headful title="Past Events | IceTiger" description="All past events" keywords="events, icetiger" :url="url"></vue-headful>
  </div>
</template>

<script>
import loading from 'vue-full-loading';

const axios = require('axios');
const API_EntryPoint = "https://api.icetiger.eu/Event/";

export default {
  name: 'PastEvents',
  components: {
    loading
  },
  data () {
    return {
      isIE: /Trident\/|MSIE/.test(window.navigator.userAgent),
      evts: [{
        "named_id": "eventId",
        "name": "Event Name",
        "subtitle": "Event Subtitle",
        "url": "#",
        "from": "0000-00-00",
        "to": "0000-00-00",
        "location": "Event Location",
        "provider": {
          "name": "Event Provider",
          "homepageUrl": "#",
          "footTwitterUrl": "#"
        }
      }],
      error: false,
      url: 'https://icetiger.eu/event/',
      isLoading: false
    }
  },
  computed: {
    events: {
      get: function() {
        return this.evts;
      },
      set: function (newVal) {
        this.evts = newVal;
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;

      axios.get(API_EntryPoint, { timeout: 5000 })
      .then(
        response => {
          this.evts = response.data;
          this.url = 'https://icetiger.eu/event/';
          this.error = false;
          this.isLoading = false;
        }
      ).catch(
        error => {
          this.error = true;
          this.url = 'https://icetiger.eu/event/';
          this.isLoading = false;
          console.log (error);
        }
      );
    }
  },
  watch: {
    '$route': 'fetchData'
  }
}

</script>
<style src="@/assets/main.css"></style>



// WEBPACK FOOTER //
// src/components/PastEvents.vue